import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { CompanyService } from '../../@core/data/company/company.service';
import { UnitCodesError, UnitCodesLoaded, UnitCodesRequested } from './unitCodes.actions';
import { PublicService } from '../../@core/data/public/public.service';
@Injectable()
export class UnitCodesEffects {
  constructor(
    private actions$: Actions,
    private publicService: PublicService
  ) {}

  requestUnitCodes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UnitCodesRequested),
      mergeMap(() =>
        this.publicService.getListOfAllUnitCodes().pipe(
          map((res: any) => {
            return res.status ? UnitCodesLoaded({ unitCodes: res?.unitCodes }) : UnitCodesLoaded({unitCodes: []})
        }),
          catchError((error: any) => of(UnitCodesError()))
        ) 
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UnitCodesError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
